import client from '@/services/client'

export default {
  state: {
    user: null
  },
  actions: {
    async registerApplication() {
      await client.get('sanctum/csrf-cookie', false)
    },

    async login(_, payload) {
      return await client.post('login', { payload }).catch(error => {
        throw error.response
      })
    },

    async getUser({ commit }) {
      return await client
        .get('auth')
        .then(response => {
          commit('setUser', response.user)
        })
        .catch(error => {
          throw error.response
        })
    },

    async logout() {
      return await client.get('logout').catch(error => {
        throw error.response
      })
    },

    async resetPassword({ state }, ident) {
      await client.get(`user/reset/${ident}?api_token=${state.authToken}`)
    },

    async setNewPassword({ state }, payload) {
      await client
        .put(`user/reset/${payload.ident}`, {
          api_token: state.authToken,
          payload
        })
        .catch(error => {
          throw error
        })
    }
  },
  mutations: {
    setUser(state, data) {
      state.user = data
    }
  }
}
